(function() {
    'use strict';
    angular.module('app')
        .controller('ConstanceController', function($scope, $location) {});
})();


// WEBPACK FOOTER //
// ./js/controllers/ConstanceController.js